import * as React from 'react'
import useRouter from 'use-react-router'

import { Header, NavbarItem } from '@espoon-voltti/react-components/components'
import { Button } from '@espoon-voltti/react-components/elements'

import { AuthStore } from '@espoon-voltti/nuora-app-common/services/use-auth'

import { localizedPathnames } from '../utils/localized-pathname'
import { t } from '../i18n'
import { LangSelector } from './lang-selector'
import * as Session from '../session'

export const AppHeader = ({ authStore }: { authStore: AuthStore }) => {
  const { history } = useRouter()
  return (
    <Header
      logo={<img src={require('../assets/EspooRGB.png')} width={160} />}
      title={t(['header', 'title', 'label'])}
      link={localizedPathnames.homeHref(history)}
      className={'slim'}
    >
      <NavbarItem align="end">
        <LangSelector />
      </NavbarItem>
      {authStore.isLoggedIn() && (
        <NavbarItem>
          <div>
            <span data-qa="fullname">{authStore.getUsername()}</span>
            {' | '}
          </div>
          <>
            <form action={Session.logoutUrl()} method="POST">
              <Button plain={true} type="submit">
                {t(['header', 'nav', 'logout'])}
              </Button>
            </form>
          </>
        </NavbarItem>
      )}
    </Header>
  )
}
